@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
}

.controls {
    position: absolute;
    top: 50%;
    inset-inline: 40px;
    transform: translateY(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-between;

    *:not(:hover, :focus-within) > & {
        display: none;
    }

    @media ($below-tablet) {
        inset-inline: 24px;
    }

    @media (hover: none) and (pointer: coarse) {
        display: none;
    }
}

.arrow {
    composes: contrast from "../../styles/composable/themes.module.css";

    &[disabled] {
        opacity: 0;
    }
}

.arrowLeft {
    composes: arrow;
    transform: rotate(180deg);
}

.arrowRight {
    composes: arrow;
}

.scrollContainer {
    scrollbar-width: none;
}

.dots {
    display: flex;
    justify-content: center;
    gap: var(--spacer-12);
    margin-top: var(--spacer-40);

    & > * {
        display: inline-block;
        width: var(--spacer-8);
        height: var(--spacer-8);
        border-radius: 50%;
        background: var(--color-contrast);

        &:not([data-active]) {
            opacity: 0.5;
        }
    }
}
